/*
"ContractStatus": {
    "required": ["itemStatus", "isBatchScanPossible"],
    "type": "object",
    "properties": {
        "itemStatus": {
            "$ref": "#/definitions/ItemStatus",
            "description": "Scanstatus der Auftragsgegenstände"
        },
        "isBatchScanPossible": {
            "description": "Batch-Scanning möglich",
            "type": "boolean"
        }
    }
}
*/
import { ItemStatus } from "./item-status";

export class ContractStatus {
  constructor(
    public itemStatus: ItemStatus,
    public isBatchScanPossible: boolean
  ) { }

  public static fromJSON(json: {
    itemStatus: any,
    isBatchScanPossible: boolean
  }): ContractStatus {
    if (!json) {
      throw new Error('ContractStatus JSON should not be undefined');
    }
    if (!json.itemStatus) {
      throw new Error('ContractStatus JSON should have property: itemStatus');
    }
    return new ContractStatus(
      ItemStatus.fromJSON(json.itemStatus),
      json.isBatchScanPossible
    );
  }
}
